import React from 'react';
import { motion } from 'framer-motion';
export function ClosingCTA() {
  return <section id="contacto" className="relative py-32 md:py-48 flex items-center justify-center text-center px-4 overflow-hidden" data-id="element-126" data-mp="2x5jr64kysqo4">
      <div className="absolute inset-0 bg-forest/80 z-10" data-id="element-127" data-mp="2i92cp4hhavxc" />
      <img src="https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&q=80" alt="Camino en el bosque" className="absolute inset-0 w-full h-full object-cover" data-id="element-128" data-mp="2n7dq1p6zfokb" />

      <div className="relative z-20 max-w-4xl mx-auto text-bone" data-id="element-129" data-mp="3azapegt8wo4j">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-7xl font-serif mb-8 leading-tight" data-id="element-130" data-mp="3fuq41az2uo20">
          El bosque es futuro
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-2xl text-bone/80 font-light mb-12 max-w-2xl mx-auto" data-id="element-131" data-mp="3turcbbho8xri">
          Súmate a este esfuerzo por la vida, el territorio y las comunidades
          que lo habitan.
        </motion.p>

        <motion.a href="https://programatefos.com/" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="inline-block bg-clay hover:bg-clay-light text-bone px-10 py-5 text-lg font-medium tracking-wide transition-colors" data-id="element-132" data-mp="15v4zfphklpsc">
          Conoce el proyecto
        </motion.a>
      </div>
    </section>;
}